import { useEffect } from 'react';
import { playerOnCancel, clearMovieDetails } from 'store/actions';

// Import helpers
import { PLAYER_SELECTORS } from 'helpers/variables';
import { fetchMovieResources } from 'components/views/vod/views/Player/helpers';
import { isHlsSupported } from 'helpers/player';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { useAuth } from 'components/utilities';

const playerType = PLAYER_SELECTORS.VOD;

const useMovieResources = ({ uuid, type = 'vod', videoId = null, isMovieDetails }) => {
	const { isAuth } = useAuth();
	const dispatch = useAppDispatch();
	const { isReady, isLoaded } = useAppSelector((state) => state[playerType]);
	const { error, errorMessage, loading: isDetailsLoading } = useAppSelector((state) => state.movieDetails);

	useEffect(() => {
		dispatch(
			fetchMovieResources({
				uuid,
				type,
				videoId,
				isAuth,
				isMovieDetails
			})
		);
		return () => {
			// Clear movie details
			!isMovieDetails && clearMovieDetails(dispatch);
			dispatch(playerOnCancel(playerType));
		};
		// eslint-disable-next-line
	}, []);

	const isHls = isHlsSupported();

	return {
		isReady,
		isLoading: !isLoaded || isDetailsLoading,
		isError: error.isError,
		errorMessage,
		playerType,
		isHls
	};
};

export default useMovieResources;
